import ApiService from './ApiService'

const ROOT_URL = '/services/onboarding/api/preference/private';

const PreferenceApi = new ApiService(ROOT_URL, '', {
  getAllByMnemonic: function (ctx, mnemonic, onSuccess, onError) {
    this.apiGET(ctx, `/getallbymnemonic?mnemonic=${mnemonic}`, onSuccess, onError);
  },
  getJitsiDomainConfigurations: function (ctx, onSuccess, onError) {
    this.apiGET(ctx, '/getallbymnemonic?mnemonic=JITSI_CONF', onSuccess, onError);
  },
  getContractManagementLink: function (ctx, onSuccess, onError) {
    this.apiGET(ctx, '/getbycode?code=CONTRACT_MANAGEMENT_LINK', onSuccess, onError);
  }
});

export default PreferenceApi;



// WEBPACK FOOTER //
// ./src/service/PreferenceService.js